export default {
  movie: 'https://www.themoviedb.org/movie/:id',
  movieImdb: 'https://www.imdb.com/title/:id/',
  movieLetterboxd: 'https://letterboxd.com/film/:slug/',
  person: 'https://www.themoviedb.org/person/:id',
  ratings: 'https://www.themoviedb.org/movie/:id/reviews',
  ratingsImdb: 'https://www.imdb.com/title/:id/ratings',
}
